// import { useEffect } from "react";
// import { toast } from "react-toastify";
// import commonService from '../services/commonService';

// function TokenGenerate() {

//     useEffect(() => {
//         const interval = setInterval(() => {
//         localStorage.removeItem("token");
//         commonService.tokenGenerator();
//         }, 60000); // 1 Min
//         // clear interval on unmount
//         return () => clearInterval(interval);
//     }, [])
// }

// export default TokenGenerate;